// Eskom PARCC — Working Papers filter bar (presentational).
//
// The Review-Status select plus a free-text search above the working-papers
// list. Option list is supplied by the page (the enum set unioned with the
// values actually present), so this component is purely controlled — it holds
// no state and does no derivation. Mirrors TransactionFilters.
import { FilterBar, SelectFilter, SearchInput, Button } from '../../components/ui';
import type { WorkingPaperFilters as Filters } from './filterWorkingPapers';

export function WorkingPaperFilters({
  filters,
  onChange,
  onReset,
  reviewStatusOptions,
  buyerOptions,
  userOptions,
}: {
  filters: Filters;
  onChange: (patch: Partial<Filters>) => void;
  onReset: () => void;
  reviewStatusOptions: readonly string[];
  buyerOptions: readonly string[];
  userOptions: readonly string[];
}): React.JSX.Element {
  return (
    <div className="filters">
      <FilterBar>
        <SelectFilter
          label="Review status"
          value={filters.reviewStatus}
          options={withAll(reviewStatusOptions, 'All review statuses')}
          onChange={(reviewStatus) => onChange({ reviewStatus })}
        />
        {/* Feedback 2b — filter (and so download) by buyer or by individual user. */}
        <SelectFilter
          label="Buyer"
          value={filters.buyer}
          options={withAll(buyerOptions, 'All buyers')}
          onChange={(buyer) => onChange({ buyer })}
        />
        <SelectFilter
          label="Assigned to"
          value={filters.user}
          options={withAll(userOptions, 'All users')}
          onChange={(user) => onChange({ user })}
        />
        <SearchInput
          label="Search"
          value={filters.search}
          placeholder="Ref, supplier, division, assignee…"
          onChange={(search) => onChange({ search })}
        />
      </FilterBar>
      <Button variant="ghost" onClick={onReset}>
        Reset filters
      </Button>
    </div>
  );
}

/** Prepend an "all" sentinel (empty value) to a value list for a select. */
function withAll(values: readonly string[], allLabel: string) {
  return [{ value: '', label: allLabel }, ...values.map((v) => ({ value: v, label: v }))];
}
